/* Groundswell custom JS */

function splitCollectionHeadings() {
// add a subheading to the collection title
  var $existingHeading = $('#shopify-section-collection-header .section-header__title').text().trim();
  
  if ($existingHeading.indexOf(" - ") !== -1) {
    var $existingHeadingArray = $existingHeading.split(" - ");
    var newHeading = '<span class="sub-heading">' + $existingHeadingArray[0] + '</span>' + $existingHeadingArray[1];
    $('#shopify-section-collection-header .section-header__title').html(newHeading);
  }
}

function geometryTableStyling() {
// Add borders to colspan columns
  var $colspan = $('.template-product #product-geometry.sticky-table th[colspan]').attr('colspan');
  console.log($colspan);
  $('.template-product #product-geometry.sticky-table td').each(function(i) {
    if (i % $colspan == 0) {
    	$(this).addClass("column");
    }
  });
}

$(document).ready(function(){
  splitCollectionHeadings();
  geometryTableStyling()
  
  $('.collection-filter__item--drawer').parent('div').addClass('filter-sticky');
  
  // Animate the product page menu scrolling
  $('.product-title-bar a[href*="#"]').on('click', function(e) {
    e.preventDefault()
    var offset = 80;
    if (window.innerWidth < 960) { offset = 120; }

    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top - offset,
    }, 500, 'linear' )
  })
  
  // Tabs UI
  $('.template-product li.tab').click(function () {
    var $tab = $(this).attr("data-tab");
    
    $('.template-product li.tab').removeClass('tab-active');
    $('.template-product .tab-content').removeClass('tab-content-active');
    
    $(this).toggleClass('tab-active');
    $("#"+$tab).toggleClass('tab-content-active');
  });
  
  // FAQs
  $('.template-product .product-faqs li').filter(':even').addClass('faq-question');
  $('.template-product .product-faqs li').filter(':odd').addClass('faq-answer');
  
  $('.template-product .product-faqs li.faq-question').click(function() {
    $(this).toggleClass('active');
    $(this).next('li.faq-answer').toggleClass('show-answer');
  });
  
  // Add container div to enable side scrolling table
  $('.template-product .sticky-table table').wrap('<div class="sticky-table-wrapper"></div>');
  
  // prevent label only links from refreshing the page
  $('.site-nav__link[href$="#"]').click(function( event ) {event.preventDefault();});
  
})